export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      skills: "Skills",
      projects: "Projects",
      certificates: "Certificates",
      blog: "Blog",
      contact: "Contact",
    },
    hero: {
      name: "Alireza Adibi",
      title: "Computer Science Student & AI Developer",
      bio: "I'm passionate about building smart systems that connect technology and human behavior. I love working on data-driven projects, AI experiments, and creative software ideas.",
      downloadResume: "📄 Download Resume",
      contactMe: "✉️ Contact Me",
      telegram: 'Telegram Channel'
    },
    about: {
      title: "About Me",
      paragraph1:
        "I'm Alireza, a 3rd-semester Computer Science student at Azad University, Tehran Central Branch. From the beginning, I've always been drawn to new things, especially those that challenge you and push you to think more and learn more.",
      paragraph2:
        "I'm currently focusing on deepening my knowledge in Deep Learning and completing my React learning. I'm taking courses, reading various resources, and working on more projects to make my experience more real and practical, gradually building a more professional path for myself.",
      paragraph3:
        "I really enjoy teamwork—in competitions and various projects, I've teamed up with different people. Some competitions were successful and we won prizes, and some were just amazing experiences where I learned a lot. Most importantly, I connected with talented and professional people and built a network that gave me a lot of motivation and fresh perspectives. Overall, I'm a curious person, I love learning, and I'm always striving to be a better version of myself, even if the path is hard and long.",
    },
    skills: {
      title: "My Skills",
      description:
        "I'm currently focused on improving my React and Artificial Intelligence skills. I'm still learning and building projects to grow faster.",
      html: "HTML",
      css: "CSS",
      javascript: "JavaScript",
      react: "React",
      python: "Python",
      ai: "AI / ML",
      django: "Django",
      git: "Git, GitHub",
      htmlLevel: "Intermediate",
      cssLevel: "Intermediate",
      jsLevel: "Intermediate",
      reactLevel: "In Progress",
      pythonLevel: "Advanced",
      aiLevel: "Learning",
      djangoLevel: "Learning",
      gitLevel: "Comfortable",
    },
    certificates: {
      title: "Certificates & Competitions",
      seeDetails: "See Details",
      olympiad: {
        title: "Olympiad of Technology 2025 – Frontend",
        description:
          "Reached the finals in the 2025 Frontend Technology Olympiad. It was a great experience that helped me improve my fundamentals and prepare over two months. I'm now focused on mastering React.",
      },
      behaviorDetection: {
        title: "Human-like Behavior Detection Project",
        description:
          "A university competition project where my teammates and I built a Random Forest model to detect human-like behavior. We won first place!",
        github: "GitHub Project Link",
      },
      dataProcessing: {
        title: "Data Processing Olympiad",
        description:
          "Participated in the Data Processing Olympiad using Python and data mining techniques. It helped strengthen my problem-solving and analytical mindset.",
      },
      aiAgent: {
        title: "AI Agent Challenge – Sharif University",
        description:
          "Joined AI Agent competitions at Sharif University and built a smart meeting assistant extension.",
      },
    },
    projects: {
      title: "Featured Projects",
      viewGitHub: "View on GitHub",
      liveDemo: "Live Demo",
      aiBotDetector: {
        name: "AI Bot Detector",
        summary:
          "Python & scikit-learn project that detects human-like behavior.",
        technologies: "Python, scikit-learn, Machine Learning",
      },
      speechToText: {
        name: "Speech-to-Text Real-Time App",
        summary:
          "Real-time voice transcription using Google, Deepgram, and Azure APIs.",
        technologies:
          "Python, FastAPI, WebSockets, Google API, Deepgram, Azure",
      },
      fastApiPortfolio: {
        name: "FastAPI Portfolio API",
        summary: "RESTful API backend for personal data and projects.",
        technologies: "Python, FastAPI, REST API",
      },
    },
    contact: {
      title: "Let's Connect",
      name: "Name",
      email: "Email",
      message: "Message",
      send: "Send",
      sending: "Sending...",
      success: "Message sent successfully!",
      error: "Failed to send message. Please try again.",
    },
    blog: {
      title: "Blog",
      description:
        "Thoughts, experiences, and insights about development, AI, and technology.",
      all: "All",
      readMore: "Read More",
      noPosts: "No blog posts available yet.",
      notFound: "Blog post not found",
      backToBlog: "Back to Blog",
    },
    footer: {
      rights: "All rights reserved.",
      madeWith: "Made with ❤️ using React",
    },
  },
  fa: {
    nav: {
      home: "خانه",
      about: "درباره من",
      skills: "مهارت‌ها",
      projects: "پروژه‌ها",
      certificates: "گواهینامه‌ها",
      blog: "وبلاگ",
      contact: "تماس",
      
    },
    hero: {
      name: "علیرضا ادیبی",
      title: "دانشجوی کامپیوتر و توسعه‌دهنده هوش مصنوعی",
      bio: "من عاشق ساختن سیستم‌های هوشمندم که فناوری و رفتار آدم‌ها رو به هم وصل می‌کنن. کلی حال می‌کنم با پروژه‌های داده‌محور، آزمایش‌های هوش مصنوعی و ایده‌های خلاقانه نرم‌افزاری و همیشه دنبال اینم که چیزای جدید یاد بگیرم و تجربه‌های واقعی جمع کنم.",
      downloadResume: "📄 دانلود رزومه",
      contactMe: "✉️ تماس با من",
      telegram: 'کانال تلگرام',
    },
    about: {
      title: "درباره من",
      paragraph1:
        "من علیرضام؛ دانشجوی ترم ۳  کامپیوتر دانشگاه آزاد تهران مرکز. از همون اول همیشه دنبال چیزای جدید بودم، مخصوصاً چیزایی که آدم رو به چالش می‌کشن و مجبورت می‌کنن بیشتر فکر کنی و بیشتر یاد بگیری. کلاً حال می‌کنم با چالش، چون آخرش همیشه حس می‌کنم یه لِول از خود دیروزم جلوتر اومدم و یه چیز جدید یاد گرفتم.",
      paragraph2:
        "این روزا بیشتر وقتم رو گذاشتم روی عمیق‌تر شدن تو Deep Learning و تکمیل یادگیری React. دارم هم‌زمان دوره می‌بینم، منابع مختلف رو می‌خونم و پروژه‌های بیشتری می‌زنم تا تجربه‌هام واقعی‌تر و کاربردی‌تر بشه و کم‌کم مسیر حرفه‌ای‌تری برای خودم بسازم.",
      paragraph3:
        "از طرفی، کلی حال می‌کنم با کار تیمی—تو مسابقه‌ها و پروژه‌های مختلف با آدمای متفاوت هم تیمی شدم. بعضی از مسابقه‌ها موفق شدیم و جایزه گرفتیم، بعضی‌هاشون هم تجربه خفن بود و کلی چیز جدید یاد گرفتم. از همه مهم‌تر این بود که با آدمای بااستعداد و حرفه‌ای ارتباط برقرار کردم و شبکه‌سازی کردم که خودش کلی انگیزه و دید تازه بهم داد. در کل آدم کنجکاوی‌ام، یادگیری رو دوست دارم و همیشه دنبال اینم که نسخه بهترِ خودم باشم؛ حتی اگه مسیرش سخت و طولانی باشه.",
    },
    skills: {
      title: "مهارت‌های من",
      description: "در حال حاضر بیشتر فوکوسم رو دیپ لرنینگ، ری‌اکت و جنگو گذاشتم و دارم با پروژه‌های واقعی پیش می‌برم.",
      html: "HTML",
      css: "CSS",
      javascript: "JavaScript",
      react: "React",
      python: "Python",
      ai: "AI / ML",
      django: "Django",
      git: "Git, GitHub",
      htmlLevel: "متوسط",
      cssLevel: "متوسط",
      jsLevel: "متوسط",
      reactLevel: "در حال یادگیری",
      pythonLevel: "پیشرفته",
      aiLevel: "در حال یادگیری",
      djangoLevel: "در حال یادگیری",
      gitLevel: "راحت",
    },
    certificates: {
      title: "گواهینامه‌ها و مسابقات",
      seeDetails: "مشاهده جزئیات",
      olympiad: {
        title: "المپیاد فناوری ۲۰۲۵ (بخش فرانت‌اند) — تا فینال رفتم 😎",
        description:
          "تجربه خفنی بود، دو ماه تمرین کردم و جمع‌بندی زدم تا آماده شم. الانم دارم رو ری‌اکت تمرکز می‌کنم و پروژه می‌زنم تا قوی‌تر شم.",
      },
      behaviorDetection: {
        title: "مسابقه تشخیص رفتار انسان‌گونه",
        description:
          "تو دانشگاه خودمون برگزار شد. من و بچه‌های تیم یه مدل Random Forest زدیم و برنده شدیم 😄",
        github: "لینک گیت‌هاب پروژه هم اینجاست 👇",
      },
      dataProcessing: {
        title: "المپیاد پردازش داده",
        description:
          "با پایتون و دیتا ماینینگ سروکله زدم 😅 باعث شد بیشتر با دید تحلیلی و الگوریتمی کار کنم.",
      },
      aiAgent: {
        title: "مسابقات AI Agent شریف",
        description:
          "تو مسابقات AI Agent شریف شرکت کردم. یه پروژه اکستنشن داشتم برای دستیار هوشمند جلسات آنلاین، اینم از تصویرش، تجربه‌ش خیلی باحال بود 😄",
      },
    },
    projects: {
      title: "پروژه‌های برجسته",
      viewGitHub: "مشاهده در GitHub",
      liveDemo: "نسخه زنده",
      aiBotDetector: {
        name: "تشخیص‌دهنده ربات هوش مصنوعی",
        summary:
          "پروژه Python و scikit-learn که رفتار شبیه انسان را تشخیص می‌دهد.",
        technologies: "Python, scikit-learn, یادگیری ماشین",
      },
      speechToText: {
        name: "اپلیکیشن تبدیل گفتار به متن در زمان واقعی",
        summary:
          "تبدیل صدا به متن در زمان واقعی با استفاده از APIهای Google، Deepgram و Azure.",
        technologies:
          "Python, FastAPI, WebSockets, Google API, Deepgram, Azure",
      },
      fastApiPortfolio: {
        name: "API پورتفولیو FastAPI",
        summary: "بک‌اند RESTful API برای داده‌های شخصی و پروژه‌ها.",
        technologies: "Python, FastAPI, REST API",
      },
    },
    contact: {
      title: "بیایید در ارتباط باشیم",
      name: "نام",
      email: "ایمیل",
      message: "پیام",
      send: "ارسال",
      sending: "در حال ارسال...",
      success: "پیام با موفقیت ارسال شد!",
      error: "ارسال پیام ناموفق بود. لطفاً دوباره تلاش کنید.",
    },
    blog: {
      title: "وبلاگ",
      description:
        "تجربیات، افکار و بینش‌های من درباره توسعه، هوش مصنوعی و فناوری.",
      all: "همه",
      readMore: "ادامه مطلب",
      noPosts: "هنوز پستی منتشر نشده است.",
      notFound: "پست وبلاگ یافت نشد",
      backToBlog: "بازگشت به وبلاگ",
    },
    footer: {
      rights: "تمام حقوق محفوظ است.",
      madeWith: "ساخته شده با ❤️ با استفاده از React",
    },
  },
};
